// This file was auto-generated by Fern from our API Definition.
export const LogicalOperator = {
    And: "and",
    Or: "or",
    Not: "not",
    Nand: "nand",
    Nor: "nor",
};
